import React from "react";
import styled from "styled-components";
import { format } from "date-fns";

interface TweetProps {
  content: string;
  author: {
    name: string;
    handle: string;
    avatar: string;
  };
  date: string;
  likes?: number;
  retweets?: number;
}

const CustomTweet: React.FC<TweetProps> = ({
  content,
  author,
  date,
  likes = 0,
  retweets = 0,
}) => {
  const formattedDate = format(new Date(date), "h:mm a · MMM d, yyyy");
  return (
    <TweetWrapper>
      <TweetHeader>
        <Avatar src={author.avatar} alt={author.name} />
        <AuthorInfo>
          <AuthorName>{author.name}</AuthorName>
          <AuthorHandle>@{author.handle}</AuthorHandle>
        </AuthorInfo>
        <TwitterLogo>
          <svg viewBox='0 0 24 24' aria-hidden='true'>
            <path
              fill='currentColor'
              d='M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z'
            />
          </svg>
        </TwitterLogo>
      </TweetHeader>

      <TweetContent>{content}</TweetContent>

      <TweetDate>{formattedDate}</TweetDate>
      <Divider />
      <TweetStats>
        <Stat>
          <strong>{retweets}</strong> Retweets
        </Stat>
        <Stat>
          <strong>{likes}</strong> Likes
        </Stat>
      </TweetStats>
    </TweetWrapper>
  );
};

const TweetWrapper = styled.div`
  max-width: 480px;
  padding: 1rem;
  border: 1px solid rgb(207, 217, 222);
  border-radius: 16px;
  margin: 1.5rem auto;
  font-family: "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, Helvetica,
    Arial, sans-serif;
`;

const TweetHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Avatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
`;

const AuthorInfo = styled.div`
  flex: 1;
`;

const AuthorName = styled.div`
  font-weight: bold;
  color: rgb(15, 20, 25);
  padding-bottom: 0px;
`;

const AuthorHandle = styled.div`
  color: rgb(83, 100, 113);
  margin-top: -4px; // Added to reduce padding from name
`;

const TwitterLogo = styled.div`
  width: 24px;
  height: 24px;
  margin-top: -24px;
`;

const TweetContent = styled.p`
  margin: 12px 0;
  font-size: 16px;
  line-height: 1.5;
  color: rgb(15, 20, 25);
`;

const TweetDate = styled.div`
  color: rgb(83, 100, 113);
  font-size: 15px;
  margin: 12px 0 8px 0; // Reduced bottom margin
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid rgb(239, 243, 244);
  margin: 12px 0;
`;

const TweetStats = styled.div`
  display: flex;
  gap: 20px;
  color: rgb(83, 100, 113);
  font-size: 15px;
  margin-top: -10px; // Added to bring it closer to the date
`;

const Stat = styled.div`
  strong {
    color: rgb(15, 20, 25);
  }
`;

export default CustomTweet;
